// Genbrugelig kolonne-overskrift med klik-til-sortér og asc/desc-pil-indikator.
// Generisk i `keyName` så hver side kan have sin egen union-type.

export type SortDir = 'asc' | 'desc';

interface Props<TKey extends string> {
  keyName: TKey;
  label: string;
  sortKey: TKey;
  sortDir: SortDir;
  onSort: (k: TKey) => void;
  alignRight?: boolean;
}

export default function SortableTh<TKey extends string>({
  keyName, label, sortKey, sortDir, onSort, alignRight = false,
}: Props<TKey>) {
  const active = sortKey === keyName;
  return (
    <th onClick={() => onSort(keyName)}
      className={`th cursor-pointer hover:bg-ink-100 select-none ${alignRight ? 'text-right' : ''}`}>
      <span className={`inline-flex items-center gap-1 ${alignRight ? 'justify-end w-full' : ''}`}>
        {label}
        <span className={`text-xs ${active ? 'text-sage-700' : 'text-ink-300'}`}>
          {active ? (sortDir === 'asc' ? '↑' : '↓') : '↕'}
        </span>
      </span>
    </th>
  );
}
